import LogoSpin from "../assets/logo-new.svg";

const LoadingComponent = () => {
  return (
    <div className="fixed inset-0 min-h-[100%] bg-[#f8fafca5] z-50 flex flex-1 grow  w-full items-center justify-center px-8">
      <img
        className="w-1/2 md:w-1/6 animate-bounce"
        src={LogoSpin}
        alt="LogoImage"
      />
    </div>
  );
};

export default LoadingComponent;
